import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=c6b95bb0&"
import script from "./CustomerService.vue?vue&type=script&lang=js&"
export * from "./CustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports